import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBoc7Q1SJ489LHS4wzWfkrTgCO5mx50aso',
  authDomain: 'parrainageimmo-ae141.firebaseapp.com',
  projectId: 'parrainageimmo-ae141',
  storageBucket: 'parrainageimmo-ae141.firebasestorage.app',
  messagingSenderId: '800238843574',
  appId: '1:800238843574:web:2defda0da56fe4ea705817',
  measurementId: 'G-0Y1GNRZNWG',
  databaseURL: 'https://parrainageimmo-ae141-default-rtdb.europe-west1.firebasedatabase.app',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;





